module.exports = __webpack_public_path__ + "media/mem_2900_m.541ea193.mp4";